import React from 'react'
import classnames from 'classnames'

export interface IButton {
  name: string
  type?: 'primary' | 'secondary' | 'text' | 'remove'
  size?: 'M' | 'L'
  disabled?: boolean
  loading?: boolean
  iconLeft?: string
  iconRight?: string
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  dataCy?: string
}

const Button = ({
  name,
  type = 'primary',
  size = 'L',
  disabled,
  loading,
  iconLeft,
  iconRight,
  className,
  onClick,
  dataCy,
}: IButton) => {
  return (
    <button
      onClick={onClick}
      data-cy={dataCy}
      className={classnames(
        `${className} flex items-center justify-center whitespace-nowrap rounded-lg px-6 font-spaceGrotesk`,
        {
          'py-2': size === 'M',
          'py-4': size === 'L',
          'bg-main-blue text-black hover:bg-white': type === 'primary',
          'bg-transparent text-white shadow-border hover:bg-white hover:text-black':
            type === 'secondary',
          'bg-transparent text-main-blue  hover:text-white': type === 'text',
          'bg-red text-white hover:bg-white hover:text-black': type === 'remove',
          'pointer-events-none opacity-50': disabled || loading,
        },
      )}>
      {loading && (
        <span className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]"></span>
      )}
      {iconLeft && <span className={`icon-${iconLeft} mr-2 text-lg leading-5`}></span>}
      {name}
      {iconRight && <span className={`icon-${iconRight} ml-2 text-lg leading-5`}></span>}
    </button>
  )
}

export default Button
